import React, { useState, useEffect } from 'react';
import classes from './EditChecklist.module.css';
import { putChecklistAction } from '../../../../Store/actions/checklistsAction';
import { useDispatch, useSelector } from 'react-redux';
import useHandleSubmit from '../../../../Hooks/useHandleSubmit';

const EditChecklist = ({ toggleModal, trialID, checklist }) => {
	const dispatch = useDispatch();

	const handleCancelClick = (ev) => {
		ev.preventDefault();
		toggleModal();
	};

	const handleChecklistSubmit = () => {
		//dispatch(postStakeholderAction(formData));
		dispatch(putChecklistAction({ trialID: trialID, checklistID: inputs.groupId, name: inputs.groupName }));
		toggleModal();
	};

	const [ canSubmit, setCanSubmit ] = useState(false);
	const allowSubmission = (ev) => {
		handleInputChange(ev);
		setCanSubmit(true);
	};

	const { inputs, handleInputChange, handleSubmit } = useHandleSubmit({
		callback: handleChecklistSubmit,
		initialState: {
			groupName: checklist.name,
			groupId: checklist.id
		}
	});

	return (
		<form className={classes['form']} onSubmit={handleSubmit}>
			<label className={classes['form__label']} htmlFor="addChecklist">
				Edit a checklist
			</label>
			<input
				className={classes['form__input']}
				type="text"
				onChange={allowSubmission}
				value={inputs.groupName}
				placeholder="Name your checklist"
				name="groupName"
				id="groupName"
			/>
			<div className={classes['form__buttons-container']}>
				<button
					onClick={handleCancelClick}
					className={[ classes['form__button'], classes['form__button--cancel'] ].join(' ')}
				>
					cancel
				</button>
				<button
					className={[
						classes['form__button'],
						canSubmit ? classes['form__button--cansubmit'] : classes['form__button--submit']
					].join(' ')}
					disabled={!canSubmit}
				>
					submit
				</button>
			</div>
		</form>
	);
};

export default EditChecklist;
